module.exports = __webpack_public_path__ + "img/5stars-forex.6ec29dfa.png";